@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_297_220_910)
internal val Res.string.abydos_name_ab01: StringResource by lazy {
      StringResource("string:abydos_name_ab01", "abydos_name_ab01", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 32),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 32),
      ))
    }

@delegate:ResourceContentHash(2_002_608_251)
internal val Res.string.abydos_name_ab02: StringResource by lazy {
      StringResource("string:abydos_name_ab02", "abydos_name_ab02", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 43, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 43, 32),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 43, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43, 32),
      ))
    }

@delegate:ResourceContentHash(-934_879_549)
internal val Res.string.abydos_name_ab03: StringResource by lazy {
      StringResource("string:abydos_name_ab03", "abydos_name_ab03", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 76, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 76, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 76, 28),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 76, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76, 28),
      ))
    }

@delegate:ResourceContentHash(-989_041_869)
internal val Res.string.abydos_name_ab05: StringResource by lazy {
      StringResource("string:abydos_name_ab05", "abydos_name_ab05", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 105, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 105, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 105, 32),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 105, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 105, 32),
      ))
    }

@delegate:ResourceContentHash(-2_012_900_131)
internal val Res.string.abydos_name_ab06: StringResource by lazy {
      StringResource("string:abydos_name_ab06", "abydos_name_ab06", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 138, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 138, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 138, 36),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 138, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138, 36),
      ))
    }

@delegate:ResourceContentHash(440_362_280)
internal val Res.string.abydos_name_ab08: StringResource by lazy {
      StringResource("string:abydos_name_ab08", "abydos_name_ab08", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 175, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 175, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 175, 32),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 175, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175, 32),
      ))
    }

@delegate:ResourceContentHash(71_049_734)
internal val Res.string.abydos_name_ab14: StringResource by lazy {
      StringResource("string:abydos_name_ab14", "abydos_name_ab14", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 208, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 208, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 208, 36),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 208, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 208, 36),
      ))
    }

@delegate:ResourceContentHash(-1_048_007_627)
internal val Res.string.abydos_name_ab15: StringResource by lazy {
      StringResource("string:abydos_name_ab15", "abydos_name_ab15", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 245, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 245, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 245, 32),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 245, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 245, 32),
      ))
    }

@delegate:ResourceContentHash(-2_091_277_150)
internal val Res.string.abydos_name_ab18: StringResource by lazy {
      StringResource("string:abydos_name_ab18", "abydos_name_ab18", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 278, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 278, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 278, 32),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 278, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 278, 32),
      ))
    }

@delegate:ResourceContentHash(1_932_136_690)
internal val Res.string.abydos_name_ab20: StringResource by lazy {
      StringResource("string:abydos_name_ab20", "abydos_name_ab20", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 311, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 311, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 311, 36),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 311, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 311, 36),
      ))
    }

@delegate:ResourceContentHash(-729_998_889)
internal val Res.string.abydos_name_ab22: StringResource by lazy {
      StringResource("string:abydos_name_ab22", "abydos_name_ab22", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 344, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 344, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 348, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 348, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 348, 60),
      ))
    }

@delegate:ResourceContentHash(1_279_460_280)
internal val Res.string.abydos_name_ab23: StringResource by lazy {
      StringResource("string:abydos_name_ab23", "abydos_name_ab23", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 409, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 405, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 413, 72),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 409, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 409, 60),
      ))
    }

@delegate:ResourceContentHash(-83_831_000)
internal val Res.string.abydos_name_ab24: StringResource by lazy {
      StringResource("string:abydos_name_ab24", "abydos_name_ab24", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 474, 92),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 466, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 486, 88),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 466, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 470, 84),
      ))
    }

@delegate:ResourceContentHash(-1_361_975_076)
internal val Res.string.abydos_name_ab27: StringResource by lazy {
      StringResource("string:abydos_name_ab27", "abydos_name_ab27", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 567, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 551, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 575, 76),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 551, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 555, 64),
      ))
    }

@delegate:ResourceContentHash(1_892_820_736)
internal val Res.string.abydos_name_ab29: StringResource by lazy {
      StringResource("string:abydos_name_ab29", "abydos_name_ab29", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 632, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 620, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 652, 60),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 620, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 620, 60),
      ))
    }

@delegate:ResourceContentHash(322_287_967)
internal val Res.string.accept_terms_label: StringResource by lazy {
      StringResource("string:accept_terms_label", "accept_terms_label", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 693, 118),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 677, 110),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 713, 122),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 677, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 681, 98),
      ))
    }

@delegate:ResourceContentHash(402_959_143)
internal val Res.string.add_coins_btn: StringResource by lazy {
      StringResource("string:add_coins_btn", "add_coins_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 812, 29),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 788, 29),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 836, 29),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 772, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 780, 29),
      ))
    }

@delegate:ResourceContentHash(127_344_776)
internal val Res.string.add_hearts_btn: StringResource by lazy {
      StringResource("string:add_hearts_btn", "add_hearts_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 842, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 818, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 866, 38),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 802, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 810, 38),
      ))
    }

@delegate:ResourceContentHash(574_653_769)
internal val Res.string.add_stars_btn: StringResource by lazy {
      StringResource("string:add_stars_btn", "add_stars_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 881, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 861, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 905, 53),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 837, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 849, 41),
      ))
    }

@delegate:ResourceContentHash(780_721_984)
internal val Res.string.all_lessons_completed: StringResource by lazy {
      StringResource("string:all_lessons_completed", "all_lessons_completed", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 935, 169),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 911, 177),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 959, 185),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 887, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 891, 157),
      ))
    }

@delegate:ResourceContentHash(-2_028_695_964)
internal val Res.string.already_have_account: StringResource by lazy {
      StringResource("string:already_have_account", "already_have_account", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1105, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1089, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1145, 80),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1041, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1049, 72),
      ))
    }

@delegate:ResourceContentHash(780_363_809)
internal val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1178, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1170, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1226, 28),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1106, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1122, 28),
      ))
    }

@delegate:ResourceContentHash(-126_962_453)
internal val Res.string.app_update_later_btn: StringResource by lazy {
      StringResource("string:app_update_later_btn", "app_update_later_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1207, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1199, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1255, 40),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1135, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1151, 36),
      ))
    }

@delegate:ResourceContentHash(-855_313_050)
internal val Res.string.app_update_ready_message: StringResource by lazy {
      StringResource("string:app_update_ready_message", "app_update_ready_message", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1248, 156),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1244, 156),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1296, 172),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1180, 144),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1188, 128),
      ))
    }

@delegate:ResourceContentHash(912_171_937)
internal val Res.string.app_update_ready_title: StringResource by lazy {
      StringResource("string:app_update_ready_title", "app_update_ready_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1405, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1401, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1469, 58),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1325, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1317, 46),
      ))
    }

@delegate:ResourceContentHash(1_667_189_651)
internal val Res.string.app_update_restart_btn: StringResource by lazy {
      StringResource("string:app_update_restart_btn", "app_update_restart_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1456, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1460, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1528, 46),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1384, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1364, 42),
      ))
    }

@delegate:ResourceContentHash(-1_732_790_943)
internal val Res.string.audio_settings_desc: StringResource by lazy {
      StringResource("string:audio_settings_desc", "audio_settings_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1503, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1503, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1575, 47),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1427, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1407, 43),
      ))
    }

@delegate:ResourceContentHash(-918_642_867)
internal val Res.string.audio_settings_title: StringResource by lazy {
      StringResource("string:audio_settings_title", "audio_settings_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1551, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1555, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1623, 48),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1479, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1451, 48),
      ))
    }

@delegate:ResourceContentHash(266_294_694)
internal val Res.string.avanti_btn: StringResource by lazy {
      StringResource("string:avanti_btn", "avanti_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1596, 26),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1608, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1672, 30),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1528, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1500, 26),
      ))
    }

@delegate:ResourceContentHash(-1_759_801_205)
internal val Res.string.avanti_excl_btn: StringResource by lazy {
      StringResource("string:avanti_excl_btn", "avanti_excl_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1623, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1639, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1703, 35),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1555, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1527, 31),
      ))
    }

@delegate:ResourceContentHash(787_911_194)
internal val Res.string.back_btn_desc: StringResource by lazy {
      StringResource("string:back_btn_desc", "back_btn_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1659, 33),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1679, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1739, 29),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1591, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1559, 33),
      ))
    }

@delegate:ResourceContentHash(777_707_802)
internal val Res.string.bar_title_builder: StringResource by lazy {
      StringResource("string:bar_title_builder", "bar_title_builder", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1733, 37),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1761, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1809, 37),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1673, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1633, 37),
      ))
    }

@delegate:ResourceContentHash(1_744_307_528)
internal val Res.string.bar_title_builder_short: StringResource by lazy {
      StringResource("string:bar_title_builder_short", "bar_title_builder_short", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1693, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1721, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1769, 39),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1633, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1593, 39),
      ))
    }

@delegate:ResourceContentHash(1_233_997_950)
internal val Res.string.bar_title_chapters: StringResource by lazy {
      StringResource("string:bar_title_chapters", "bar_title_chapters", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1812, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1844, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1888, 38),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1752, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1712, 34),
      ))
    }

@delegate:ResourceContentHash(-1_447_931_543)
internal val Res.string.bar_title_chapters_short: StringResource by lazy {
      StringResource("string:bar_title_chapters_short", "bar_title_chapters_short", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1771, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1799, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1847, 40),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1711, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1671, 40),
      ))
    }

@delegate:ResourceContentHash(1_380_290_770)
internal val Res.string.bar_title_compendio: StringResource by lazy {
      StringResource("string:bar_title_compendio", "bar_title_compendio", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1889, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1925, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1969, 43),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1829, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1789, 43),
      ))
    }

@delegate:ResourceContentHash(1_959_259_213)
internal val Res.string.bar_title_compendio_short: StringResource by lazy {
      StringResource("string:bar_title_compendio_short", "bar_title_compendio_short", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1847, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1883, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1927, 41),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1787, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1747, 41),
      ))
    }

@delegate:ResourceContentHash(2_036_171_224)
internal val Res.string.bar_title_personaggi: StringResource by lazy {
      StringResource("string:bar_title_personaggi", "bar_title_personaggi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1976, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2008, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2056, 44),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1912, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1876, 44),
      ))
    }

@delegate:ResourceContentHash(594_459_096)
internal val Res.string.bar_title_personaggi_short: StringResource by lazy {
      StringResource("string:bar_title_personaggi_short", "bar_title_personaggi_short", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 1933, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1965, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2013, 42),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1869, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1833, 42),
      ))
    }

@delegate:ResourceContentHash(431_655_973)
internal val Res.string.bar_title_profile: StringResource by lazy {
      StringResource("string:bar_title_profile", "bar_title_profile", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2057, 33),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2089, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2137, 33),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1993, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1957, 37),
      ))
    }

@delegate:ResourceContentHash(1_584_964_700)
internal val Res.string.bar_title_profile_short: StringResource by lazy {
      StringResource("string:bar_title_profile_short", "bar_title_profile_short", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2021, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2053, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2101, 35),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 1957, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1921, 35),
      ))
    }

@delegate:ResourceContentHash(2_047_378_352)
internal val Res.string.builder_cartouche_label: StringResource by lazy {
      StringResource("string:builder_cartouche_label", "builder_cartouche_label", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2091, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2123, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2171, 43),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2031, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1995, 43),
      ))
    }

@delegate:ResourceContentHash(2_096_963_084)
internal val Res.string.builder_copied_toast: StringResource by lazy {
      StringResource("string:builder_copied_toast", "builder_copied_toast", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2135, 80),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2167, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2215, 84),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2075, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2039, 68),
      ))
    }

@delegate:ResourceContentHash(709_164_266)
internal val Res.string.builder_copy_btn: StringResource by lazy {
      StringResource("string:builder_copy_btn", "builder_copy_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2216, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2248, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2300, 32),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2148, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2108, 32),
      ))
    }

@delegate:ResourceContentHash(1_274_321_869)
internal val Res.string.builder_delete_btn: StringResource by lazy {
      StringResource("string:builder_delete_btn", "builder_delete_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2253, 38),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2281, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2333, 38),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2181, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2141, 34),
      ))
    }

@delegate:ResourceContentHash(-1_574_947_656)
internal val Res.string.builder_delete_confirm_desc: StringResource by lazy {
      StringResource("string:builder_delete_confirm_desc", "builder_delete_confirm_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2292, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2320, 119),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2372, 111),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2220, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2176, 99),
      ))
    }

@delegate:ResourceContentHash(1_880_157_267)
internal val Res.string.builder_delete_confirm_title: StringResource by lazy {
      StringResource("string:builder_delete_confirm_title", "builder_delete_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2404, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2440, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2484, 60),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2328, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2276, 52),
      ))
    }

@delegate:ResourceContentHash(1_652_621_752)
internal val Res.string.builder_edit_btn: StringResource by lazy {
      StringResource("string:builder_edit_btn", "builder_edit_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2461, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2501, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2545, 36),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2385, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2329, 32),
      ))
    }

@delegate:ResourceContentHash(1_610_583_596)
internal val Res.string.builder_edit_dialog_title: StringResource by lazy {
      StringResource("string:builder_edit_dialog_title", "builder_edit_dialog_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2502, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2534, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2582, 53),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2422, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2362, 45),
      ))
    }

@delegate:ResourceContentHash(797_952_822)
internal val Res.string.builder_example_assembly_meaning: StringResource by lazy {
      StringResource("string:builder_example_assembly_meaning", "builder_example_assembly_meaning", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2556, 136),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2588, 136),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2636, 148),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2476, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2408, 120),
      ))
    }

@delegate:ResourceContentHash(-975_387_952)
internal val Res.string.builder_example_assembly_title: StringResource by lazy {
      StringResource("string:builder_example_assembly_title", "builder_example_assembly_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2693, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2725, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2785, 54),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2601, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2529, 50),
      ))
    }

@delegate:ResourceContentHash(-1_439_568_014)
internal val Res.string.builder_example_height_meaning: StringResource by lazy {
      StringResource("string:builder_example_height_meaning", "builder_example_height_meaning", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2748, 98),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2776, 98),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2840, 98),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2652, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2580, 90),
      ))
    }

@delegate:ResourceContentHash(-741_744_336)
internal val Res.string.builder_example_height_title: StringResource by lazy {
      StringResource("string:builder_example_height_title", "builder_example_height_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2847, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2875, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2939, 48),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2751, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2671, 44),
      ))
    }

@delegate:ResourceContentHash(1_986_332_338)
internal val Res.string.builder_example_juxtapose_meaning: StringResource by lazy {
      StringResource("string:builder_example_juxtapose_meaning", "builder_example_juxtapose_meaning", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 2892, 113),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2920, 121),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2988, 121),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2800, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2716, 117),
      ))
    }

@delegate:ResourceContentHash(-194_606_421)
internal val Res.string.builder_example_juxtapose_title: StringResource by lazy {
      StringResource("string:builder_example_juxtapose_title", "builder_example_juxtapose_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3006, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3042, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3110, 59),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2898, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2834, 55),
      ))
    }

@delegate:ResourceContentHash(1_563_313_821)
internal val Res.string.builder_example_width_meaning: StringResource by lazy {
      StringResource("string:builder_example_width_meaning", "builder_example_width_meaning", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3066, 97),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3098, 101),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3170, 97),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 2954, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2890, 89),
      ))
    }

@delegate:ResourceContentHash(-430_102_303)
internal val Res.string.builder_example_width_title: StringResource by lazy {
      StringResource("string:builder_example_width_title", "builder_example_width_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3164, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3200, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3268, 47),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3056, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2980, 43),
      ))
    }

@delegate:ResourceContentHash(-719_320_294)
internal val Res.string.builder_examples_title: StringResource by lazy {
      StringResource("string:builder_examples_title", "builder_examples_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3208, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3248, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3316, 50),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3104, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3024, 50),
      ))
    }

@delegate:ResourceContentHash(313_363_705)
internal val Res.string.builder_export_png_desc: StringResource by lazy {
      StringResource("string:builder_export_png_desc", "builder_export_png_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3259, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3307, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3367, 51),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3159, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3075, 47),
      ))
    }

@delegate:ResourceContentHash(-64_131_342)
internal val Res.string.builder_hiero_list_title: StringResource by lazy {
      StringResource("string:builder_hiero_list_title", "builder_hiero_list_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3311, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3355, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3419, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3207, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3123, 56),
      ))
    }

@delegate:ResourceContentHash(28_601_564)
internal val Res.string.builder_no_saved_words: StringResource by lazy {
      StringResource("string:builder_no_saved_words", "builder_no_saved_words", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3368, 138),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3420, 150),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3484, 194),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3268, 170),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3180, 150),
      ))
    }

@delegate:ResourceContentHash(-98_573_600)
internal val Res.string.builder_placeholder: StringResource by lazy {
      StringResource("string:builder_placeholder", "builder_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3507, 91),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3571, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3679, 83),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3439, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3331, 83),
      ))
    }

@delegate:ResourceContentHash(904_649_286)
internal val Res.string.builder_pro_feature_desc: StringResource by lazy {
      StringResource("string:builder_pro_feature_desc", "builder_pro_feature_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3599, 232),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3667, 268),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3763, 284),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3531, 244),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3415, 220),
      ))
    }

@delegate:ResourceContentHash(-1_858_625_000)
internal val Res.string.builder_pro_feature_title: StringResource by lazy {
      StringResource("string:builder_pro_feature_title", "builder_pro_feature_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3832, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3936, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4048, 61),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3776, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3636, 49),
      ))
    }

@delegate:ResourceContentHash(1_890_738_794)
internal val Res.string.builder_pro_unlock_btn: StringResource by lazy {
      StringResource("string:builder_pro_unlock_btn", "builder_pro_unlock_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3882, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3986, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4110, 50),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3834, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3686, 46),
      ))
    }

@delegate:ResourceContentHash(-1_122_449_650)
internal val Res.string.builder_rtl_label: StringResource by lazy {
      StringResource("string:builder_rtl_label", "builder_rtl_label", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3937, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4037, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4161, 53),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3881, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3733, 45),
      ))
    }

@delegate:ResourceContentHash(-1_220_154_335)
internal val Res.string.builder_save_btn: StringResource by lazy {
      StringResource("string:builder_save_btn", "builder_save_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 3987, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4095, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4215, 40),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3935, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3779, 32),
      ))
    }

@delegate:ResourceContentHash(101_333_075)
internal val Res.string.builder_save_dialog_title: StringResource by lazy {
      StringResource("string:builder_save_dialog_title", "builder_save_dialog_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4024, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4132, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4256, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 3968, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3812, 45),
      ))
    }

@delegate:ResourceContentHash(1_978_098_254)
internal val Res.string.builder_saved_words_title: StringResource by lazy {
      StringResource("string:builder_saved_words_title", "builder_saved_words_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4078, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4186, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4314, 61),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4018, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3858, 53),
      ))
    }

@delegate:ResourceContentHash(1_437_267_619)
internal val Res.string.builder_search_hint: StringResource by lazy {
      StringResource("string:builder_search_hint", "builder_search_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4148, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4252, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4376, 83),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4080, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3912, 63),
      ))
    }

@delegate:ResourceContentHash(-181_869_703)
internal val Res.string.builder_share_desc: StringResource by lazy {
      StringResource("string:builder_share_desc", "builder_share_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4216, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4324, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4460, 38),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4148, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3976, 34),
      ))
    }

@delegate:ResourceContentHash(-341_557_584)
internal val Res.string.builder_title: StringResource by lazy {
      StringResource("string:builder_title", "builder_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4251, 37),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4363, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4499, 37),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4187, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4011, 37),
      ))
    }

@delegate:ResourceContentHash(1_202_783_417)
internal val Res.string.builder_unrecognized_prefix: StringResource by lazy {
      StringResource("string:builder_unrecognized_prefix", "builder_unrecognized_prefix", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4289, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4401, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4537, 59),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4225, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4049, 59),
      ))
    }

@delegate:ResourceContentHash(1_958_942_529)
internal val Res.string.builder_word_meaning_label: StringResource by lazy {
      StringResource("string:builder_word_meaning_label", "builder_word_meaning_label", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4353, 78),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4465, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4597, 82),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4293, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4109, 70),
      ))
    }

@delegate:ResourceContentHash(-740_465_619)
internal val Res.string.builder_word_title_label: StringResource by lazy {
      StringResource("string:builder_word_title_label", "builder_word_title_label", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4432, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4540, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4680, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4368, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4180, 56),
      ))
    }

@delegate:ResourceContentHash(141_494_415)
internal val Res.string.calendar_prompt_btn_add: StringResource by lazy {
      StringResource("string:calendar_prompt_btn_add", "calendar_prompt_btn_add", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4489, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4597, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4737, 59),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4425, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4237, 51),
      ))
    }

@delegate:ResourceContentHash(46_244_938)
internal val Res.string.calendar_prompt_btn_later: StringResource by lazy {
      StringResource("string:calendar_prompt_btn_later", "calendar_prompt_btn_later", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4553, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4657, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4797, 53),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4489, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4289, 45),
      ))
    }

@delegate:ResourceContentHash(-1_779_121_050)
internal val Res.string.calendar_prompt_event_description: StringResource by lazy {
      StringResource("string:calendar_prompt_event_description", "calendar_prompt_event_description", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4603, 105),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4703, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4851, 121),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4535, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4335, 101),
      ))
    }

@delegate:ResourceContentHash(-1_641_177_157)
internal val Res.string.calendar_prompt_event_title: StringResource by lazy {
      StringResource("string:calendar_prompt_event_title", "calendar_prompt_event_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4709, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4813, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4973, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4649, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4437, 59),
      ))
    }

@delegate:ResourceContentHash(1_654_621_031)
internal val Res.string.calendar_prompt_feedback: StringResource by lazy {
      StringResource("string:calendar_prompt_feedback", "calendar_prompt_feedback", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4769, 184),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4881, 168),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5041, 180),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4713, 172),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4497, 144),
      ))
    }

@delegate:ResourceContentHash(-578_848_824)
internal val Res.string.calendar_prompt_title: StringResource by lazy {
      StringResource("string:calendar_prompt_title", "calendar_prompt_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4954, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5050, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5222, 73),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4886, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4642, 57),
      ))
    }

@delegate:ResourceContentHash(1_827_475_226)
internal val Res.string.cancel: StringResource by lazy {
      StringResource("string:cancel", "cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5020, 26),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5120, 26),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5296, 26),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4952, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4700, 22),
      ))
    }

@delegate:ResourceContentHash(258_790_654)
internal val Res.string.card_exchange_hearts: StringResource by lazy {
      StringResource("string:card_exchange_hearts", "card_exchange_hearts", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5047, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5147, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5323, 40),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 4979, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4723, 40),
      ))
    }

@delegate:ResourceContentHash(279_562_096)
internal val Res.string.card_refill_hearts: StringResource by lazy {
      StringResource("string:card_refill_hearts", "card_refill_hearts", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5088, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5188, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5364, 38),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5020, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4764, 34),
      ))
    }

@delegate:ResourceContentHash(691_389_591)
internal val Res.string.card_title_determinativo: StringResource by lazy {
      StringResource("string:card_title_determinativo", "card_title_determinativo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5131, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5227, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5403, 52),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5059, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4799, 52),
      ))
    }

@delegate:ResourceContentHash(-149_035_074)
internal val Res.string.card_title_fonogramma: StringResource by lazy {
      StringResource("string:card_title_fonogramma", "card_title_fonogramma", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5180, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5280, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5456, 53),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5112, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4852, 49),
      ))
    }

@delegate:ResourceContentHash(-1_083_463_294)
internal val Res.string.card_title_ideogramma: StringResource by lazy {
      StringResource("string:card_title_ideogramma", "card_title_ideogramma", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5230, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5334, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5510, 45),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5166, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4902, 41),
      ))
    }

@delegate:ResourceContentHash(1_225_332_944)
internal val Res.string.card_unlimited_hearts: StringResource by lazy {
      StringResource("string:card_unlimited_hearts", "card_unlimited_hearts", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5272, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5376, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5556, 41),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5212, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4944, 41),
      ))
    }

@delegate:ResourceContentHash(179_033_449)
internal val Res.string.changelog_15_0_0_item_1: StringResource by lazy {
      StringResource("string:changelog_15_0_0_item_1", "changelog_15_0_0_item_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5318, 211),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5422, 231),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5598, 247),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5258, 203),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4986, 199),
      ))
    }

@delegate:ResourceContentHash(1_523_543_179)
internal val Res.string.changelog_15_0_0_item_2: StringResource by lazy {
      StringResource("string:changelog_15_0_0_item_2", "changelog_15_0_0_item_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5530, 95),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5654, 111),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5846, 107),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5462, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5186, 87),
      ))
    }

@delegate:ResourceContentHash(-2_098_861_823)
internal val Res.string.changelog_15_0_0_item_3: StringResource by lazy {
      StringResource("string:changelog_15_0_0_item_3", "changelog_15_0_0_item_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5626, 123),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5766, 143),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5954, 143),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5562, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5274, 123),
      ))
    }

@delegate:ResourceContentHash(-1_970_581_044)
internal val Res.string.changelog_15_0_0_item_4: StringResource by lazy {
      StringResource("string:changelog_15_0_0_item_4", "changelog_15_0_0_item_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5750, 123),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5910, 143),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6098, 151),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5686, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5398, 135),
      ))
    }

@delegate:ResourceContentHash(-1_273_707_402)
internal val Res.string.changelog_15_0_0_item_5: StringResource by lazy {
      StringResource("string:changelog_15_0_0_item_5", "changelog_15_0_0_item_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5874, 155),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6054, 171),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6250, 183),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5826, 163),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5534, 151),
      ))
    }

@delegate:ResourceContentHash(-1_877_664_256)
internal val Res.string.changelog_15_0_2_item_1: StringResource by lazy {
      StringResource("string:changelog_15_0_2_item_1", "changelog_15_0_2_item_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6030, 179),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6226, 175),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6434, 187),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 5990, 199),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5686, 139),
      ))
    }

@delegate:ResourceContentHash(-1_190_368_502)
internal val Res.string.changelog_15_0_2_item_2: StringResource by lazy {
      StringResource("string:changelog_15_0_2_item_2", "changelog_15_0_2_item_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6210, 163),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6402, 163),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6622, 171),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 6190, 159),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5826, 171),
      ))
    }

@delegate:ResourceContentHash(1_720_946_180)
internal val Res.string.changelog_15_0_2_item_3: StringResource by lazy {
      StringResource("string:changelog_15_0_2_item_3", "changelog_15_0_2_item_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6374, 147),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6566, 175),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6794, 183),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 6350, 167),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5998, 143),
      ))
    }

@delegate:ResourceContentHash(342_185_231)
internal val Res.string.changelog_15_0_2_item_4: StringResource by lazy {
      StringResource("string:changelog_15_0_2_item_4", "changelog_15_0_2_item_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6522, 95),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6742, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6978, 115),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 6518, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6142, 79),
      ))
    }

@delegate:ResourceContentHash(1_034_190_927)
internal val Res.string.changelog_15_0_2_item_5: StringResource by lazy {
      StringResource("string:changelog_15_0_2_item_5", "changelog_15_0_2_item_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6618, 271),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6838, 303),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7094, 311),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 6614, 291),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6222, 239),
      ))
    }

@delegate:ResourceContentHash(-1_407_760_823)
internal val Res.string.changelog_15_0_3_item_1: StringResource by lazy {
      StringResource("string:changelog_15_0_3_item_1", "changelog_15_0_3_item_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6890, 155),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7142, 155),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7406, 171),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 6906, 147),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6462, 135),
      ))
    }

@delegate:ResourceContentHash(782_169_711)
internal val Res.string.changelog_15_0_3_item_2: StringResource by lazy {
      StringResource("string:changelog_15_0_3_item_2", "changelog_15_0_3_item_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 7046, 123),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7298, 135),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7578, 151),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 7054, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6598, 123),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("abydos_name_ab01", Res.string.abydos_name_ab01)
  map.put("abydos_name_ab02", Res.string.abydos_name_ab02)
  map.put("abydos_name_ab03", Res.string.abydos_name_ab03)
  map.put("abydos_name_ab05", Res.string.abydos_name_ab05)
  map.put("abydos_name_ab06", Res.string.abydos_name_ab06)
  map.put("abydos_name_ab08", Res.string.abydos_name_ab08)
  map.put("abydos_name_ab14", Res.string.abydos_name_ab14)
  map.put("abydos_name_ab15", Res.string.abydos_name_ab15)
  map.put("abydos_name_ab18", Res.string.abydos_name_ab18)
  map.put("abydos_name_ab20", Res.string.abydos_name_ab20)
  map.put("abydos_name_ab22", Res.string.abydos_name_ab22)
  map.put("abydos_name_ab23", Res.string.abydos_name_ab23)
  map.put("abydos_name_ab24", Res.string.abydos_name_ab24)
  map.put("abydos_name_ab27", Res.string.abydos_name_ab27)
  map.put("abydos_name_ab29", Res.string.abydos_name_ab29)
  map.put("accept_terms_label", Res.string.accept_terms_label)
  map.put("add_coins_btn", Res.string.add_coins_btn)
  map.put("add_hearts_btn", Res.string.add_hearts_btn)
  map.put("add_stars_btn", Res.string.add_stars_btn)
  map.put("all_lessons_completed", Res.string.all_lessons_completed)
  map.put("already_have_account", Res.string.already_have_account)
  map.put("app_name", Res.string.app_name)
  map.put("app_update_later_btn", Res.string.app_update_later_btn)
  map.put("app_update_ready_message", Res.string.app_update_ready_message)
  map.put("app_update_ready_title", Res.string.app_update_ready_title)
  map.put("app_update_restart_btn", Res.string.app_update_restart_btn)
  map.put("audio_settings_desc", Res.string.audio_settings_desc)
  map.put("audio_settings_title", Res.string.audio_settings_title)
  map.put("avanti_btn", Res.string.avanti_btn)
  map.put("avanti_excl_btn", Res.string.avanti_excl_btn)
  map.put("back_btn_desc", Res.string.back_btn_desc)
  map.put("bar_title_builder", Res.string.bar_title_builder)
  map.put("bar_title_builder_short", Res.string.bar_title_builder_short)
  map.put("bar_title_chapters", Res.string.bar_title_chapters)
  map.put("bar_title_chapters_short", Res.string.bar_title_chapters_short)
  map.put("bar_title_compendio", Res.string.bar_title_compendio)
  map.put("bar_title_compendio_short", Res.string.bar_title_compendio_short)
  map.put("bar_title_personaggi", Res.string.bar_title_personaggi)
  map.put("bar_title_personaggi_short", Res.string.bar_title_personaggi_short)
  map.put("bar_title_profile", Res.string.bar_title_profile)
  map.put("bar_title_profile_short", Res.string.bar_title_profile_short)
  map.put("builder_cartouche_label", Res.string.builder_cartouche_label)
  map.put("builder_copied_toast", Res.string.builder_copied_toast)
  map.put("builder_copy_btn", Res.string.builder_copy_btn)
  map.put("builder_delete_btn", Res.string.builder_delete_btn)
  map.put("builder_delete_confirm_desc", Res.string.builder_delete_confirm_desc)
  map.put("builder_delete_confirm_title", Res.string.builder_delete_confirm_title)
  map.put("builder_edit_btn", Res.string.builder_edit_btn)
  map.put("builder_edit_dialog_title", Res.string.builder_edit_dialog_title)
  map.put("builder_example_assembly_meaning", Res.string.builder_example_assembly_meaning)
  map.put("builder_example_assembly_title", Res.string.builder_example_assembly_title)
  map.put("builder_example_height_meaning", Res.string.builder_example_height_meaning)
  map.put("builder_example_height_title", Res.string.builder_example_height_title)
  map.put("builder_example_juxtapose_meaning", Res.string.builder_example_juxtapose_meaning)
  map.put("builder_example_juxtapose_title", Res.string.builder_example_juxtapose_title)
  map.put("builder_example_width_meaning", Res.string.builder_example_width_meaning)
  map.put("builder_example_width_title", Res.string.builder_example_width_title)
  map.put("builder_examples_title", Res.string.builder_examples_title)
  map.put("builder_export_png_desc", Res.string.builder_export_png_desc)
  map.put("builder_hiero_list_title", Res.string.builder_hiero_list_title)
  map.put("builder_no_saved_words", Res.string.builder_no_saved_words)
  map.put("builder_placeholder", Res.string.builder_placeholder)
  map.put("builder_pro_feature_desc", Res.string.builder_pro_feature_desc)
  map.put("builder_pro_feature_title", Res.string.builder_pro_feature_title)
  map.put("builder_pro_unlock_btn", Res.string.builder_pro_unlock_btn)
  map.put("builder_rtl_label", Res.string.builder_rtl_label)
  map.put("builder_save_btn", Res.string.builder_save_btn)
  map.put("builder_save_dialog_title", Res.string.builder_save_dialog_title)
  map.put("builder_saved_words_title", Res.string.builder_saved_words_title)
  map.put("builder_search_hint", Res.string.builder_search_hint)
  map.put("builder_share_desc", Res.string.builder_share_desc)
  map.put("builder_title", Res.string.builder_title)
  map.put("builder_unrecognized_prefix", Res.string.builder_unrecognized_prefix)
  map.put("builder_word_meaning_label", Res.string.builder_word_meaning_label)
  map.put("builder_word_title_label", Res.string.builder_word_title_label)
  map.put("calendar_prompt_btn_add", Res.string.calendar_prompt_btn_add)
  map.put("calendar_prompt_btn_later", Res.string.calendar_prompt_btn_later)
  map.put("calendar_prompt_event_description", Res.string.calendar_prompt_event_description)
  map.put("calendar_prompt_event_title", Res.string.calendar_prompt_event_title)
  map.put("calendar_prompt_feedback", Res.string.calendar_prompt_feedback)
  map.put("calendar_prompt_title", Res.string.calendar_prompt_title)
  map.put("cancel", Res.string.cancel)
  map.put("card_exchange_hearts", Res.string.card_exchange_hearts)
  map.put("card_refill_hearts", Res.string.card_refill_hearts)
  map.put("card_title_determinativo", Res.string.card_title_determinativo)
  map.put("card_title_fonogramma", Res.string.card_title_fonogramma)
  map.put("card_title_ideogramma", Res.string.card_title_ideogramma)
  map.put("card_unlimited_hearts", Res.string.card_unlimited_hearts)
  map.put("changelog_15_0_0_item_1", Res.string.changelog_15_0_0_item_1)
  map.put("changelog_15_0_0_item_2", Res.string.changelog_15_0_0_item_2)
  map.put("changelog_15_0_0_item_3", Res.string.changelog_15_0_0_item_3)
  map.put("changelog_15_0_0_item_4", Res.string.changelog_15_0_0_item_4)
  map.put("changelog_15_0_0_item_5", Res.string.changelog_15_0_0_item_5)
  map.put("changelog_15_0_2_item_1", Res.string.changelog_15_0_2_item_1)
  map.put("changelog_15_0_2_item_2", Res.string.changelog_15_0_2_item_2)
  map.put("changelog_15_0_2_item_3", Res.string.changelog_15_0_2_item_3)
  map.put("changelog_15_0_2_item_4", Res.string.changelog_15_0_2_item_4)
  map.put("changelog_15_0_2_item_5", Res.string.changelog_15_0_2_item_5)
  map.put("changelog_15_0_3_item_1", Res.string.changelog_15_0_3_item_1)
  map.put("changelog_15_0_3_item_2", Res.string.changelog_15_0_3_item_2)
}
